<template>
  <div>
    <div v-if="parameter">
      <router-link
        v-if="$keycloak.hasRealmRole('root')"
        :to="{name:'quoteParameter', params:{id:parameter.id}}"
      >
        <span v-if="parameterType">{{parameterType.name}}</span>
        <span v-else>{{parameter.id}}</span>
      </router-link>
      <span v-if="fallback">
        <i>&#160;fallback</i>
      </span>
      <EvaluateLogs :logs="parameter.logs" />
    </div>
    <div v-else>Null parameter??</div>
  </div>
</template>

<script>
import EvaluateLogs from "@/components/quote/evaluate/Logs";
export default {
  name: "Parameter",
  props: ["value", "parameterTypesMap"],
  components: { EvaluateLogs },
  computed: {
    fallback() {
      return this.value.parameter ? false : true;
    },
    parameter() {
      return this.fallback
        ? this.value.parameterFallback
        : this.value.parameter;
    },
    parameterType() {
      return this.parameterTypesMap
        ? this.parameterTypesMap[this.parameter.parametertypeid]
        : undefined;
    }
  }
};
</script>